package io.github.kingsword09.symbolcraft.symbols.icons.svgl

import androidx.compose.ui.graphics.vector.ImageVector
import io.github.kingsword09.symbolcraft.symbols.icons.svgl.icons.WindowsSvgl
import io.github.kingsword09.symbolcraft.symbols.icons.svgl.icons.XboxSvgl
import kotlin.collections.List as ____KtList

public object Icons

private var __AllIcons: ____KtList<ImageVector>? = null

public val Icons.AllIcons: ____KtList<ImageVector>
  get() {
    if (__AllIcons != null) {
      return __AllIcons!!
    }
    __AllIcons= listOf(WindowsSvgl, XboxSvgl)
    return __AllIcons!!
  }
